import InstructionsOverlay from "./InstructionsOverlay";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
function Container(props) {
    const { t } = useTranslation();
    const overlays = useSelector((state) => state.session.overlays.overlays);
    const closeOverlay = React.useCallback((key) => {
        props.onClose(key);
    }, []);
    return (React.createElement("div", { style: { position: "absolute", top: 0, left: 0, width: 0, height: 0 } }, Object.keys(overlays).map((id) => (React.createElement(InstructionsOverlay, { t: t, key: id, overlay: overlays[id], overlayId: id, onClose: closeOverlay })))));
}
export default Container;
